import React from 'react';

const SizeDetailFieldSet = (props) => {
    if (props.hidden)
        return '';

    return (
        <div>
            <div className="input-group rounded-0">   
                <div className="rounded-0 input-group-prepend" style={{width: 15 + '%'}}>
                    <span className="input-group-text rounded-0 bg-white border-0 text-left pl-0">FY{props.fy}</span>
                </div>
                <input
                    className="form-control rounded-0"
                    type="text"
                    name={"size-" + props.fy}
                    value={props.size ? props.size : ''}
                    disabled={props.disabled}
                    fy={props.fy}
                    onChange={props.onInputChange}
                    autoComplete="off" />
                <span className="input-group-append rounded-0">
                    <span className="input-group-text">
                        {props.numeraireSymbol}
                    </span>
                </span>
            </div>
        </div>
    );
}

export default SizeDetailFieldSet;
